import type { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import type { Permission } from '@/entities/user/types';
import { useHasScope } from '@/shared/hooks/useScopeGuard';

interface ScopeGuardProps {
  readonly required: readonly Permission[];
  readonly fallbackTo?: string;
  readonly children: ReactNode;
}

/**
 * Bloquea el acceso a una ruta si el usuario no tiene los scopes requeridos.
 * Se usa anidado dentro de ProtectedRoute (no autentica, solo autoriza).
 *
 * IMPORTANTE: la UI esconde, no protege. La autoridad sigue siendo el backend.
 */
export function ScopeGuard({
  required,
  fallbackTo = '/',
  children,
}: ScopeGuardProps): ReactElement {
  const allowed = useHasScope(...required);
  if (!allowed) {
    return <Navigate to={fallbackTo} replace />;
  }
  return <>{children}</>;
}
